// Local, backend-independent draft backup for manuscript chapters.
// Survives a sleeping/unreachable backend, page refreshes and navigation so
// typed work is never lost. Drafts are cleared the moment a save is confirmed.
const PREFIX = "codexstudio:draft:";

export function saveDraft(id, html) {
  if (!id) return;
  try {
    localStorage.setItem(PREFIX + id, JSON.stringify({ html, ts: Date.now() }));
  } catch { /* quota or private mode — ignore */ }
}

export function getDraft(id) {
  if (!id) return null;
  try {
    const raw = localStorage.getItem(PREFIX + id);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearDraft(id) {
  if (!id) return;
  try { localStorage.removeItem(PREFIX + id); } catch { /* ignore */ }
}

export function allDraftIds() {
  const ids = [];
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && k.startsWith(PREFIX)) ids.push(k.slice(PREFIX.length));
    }
  } catch { /* ignore */ }
  return ids;
}
